import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const base_url = 'https://mosquepay.org/mosquepayapi/v1/api';

export const api_header = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'x-api-key': '987655'
}

export const formdata_api_header = {
    'Content-type': 'multipart/form-data',
    'x-api-key': '987655'
}

export const showSuccessMessage = (message) => {
    toast.success(message);
    return null
}

export const showErrorMessage = (message) => {
    toast.error(message);
    return null
}


export const retrieveFromLocalStorage = (keys) => {
    const data = {};
    keys.forEach((key) => {
        const persistedState = localStorage.getItem(key);
        try {
            data[key] = persistedState ? JSON.parse(persistedState) : null;
        } catch (error) {
            console.error(`Error parsing JSON for key "${key}":`, error);
            data[key] = null;
        }
    });
    return data;
}
